import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
  })
  return function onChange() {
    change(next => {
      next.data.new_task = {
        ...next.data.new_task,
        actions: [{ id: 'letter', document_template_id: null }],
      }
    })
  }
}
